import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { DatePicker } from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import Info from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/Icons/Info';
import Typography from '@HomaHealth/ui-component-library/lib/_patient-access-components/atoms/Typography';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import moment from 'moment';
import React from 'react';
import { DateType } from '../CustomDateSelectionDropdown';
import { formatDate } from '../../../core-utils/helper-utils/helper';

export interface CustomDateSelectionProps {
  inputModalDates: DateType;
  setInputModalDates: React.Dispatch<React.SetStateAction<DateType>>;
}

const CustomDateSelection: React.FC<CustomDateSelectionProps> = ({
  inputModalDates,
  setInputModalDates,
}) => {
  const { classes } = makeStyles()({
    flex: {
      display: 'flex',
      gap: '1rem',
      width: '100%',
    },
    selectDatesInfo: {
      width: '100%',
      height: '37px',
      background: patientAccessTheme.palette.AIQChips?.infoBackground,
      border: '1px solid ' + patientAccessTheme.palette.grey[300],
      borderRadius: '0.25rem',
      display: 'flex',
      alignItems: 'center',
      marginBottom: '1rem',
    },
  })();

  const handleStartDateChange = (value: string | Date) => {
    const start = moment(value);
    const end = moment(start).add(11, 'months').endOf('month');

    setInputModalDates({
      startDate: start.startOf('month').format('YYYY-MM-DD'),
      endDate: end.endOf('month').format('YYYY-MM-DD'),
    });
  };

  const currentYear = moment().year();
  const minStartDate = moment()
    .year(currentYear - 20)
    .startOf('year');
  const maxStartDate = moment()
    .year(currentYear + 20)
    .endOf('year');

  return (
    <Grid container>
      <Grid className={classes.selectDatesInfo}>
        <Info
          height={'16px'}
          width="16px"
          style={{ marginRight: '8px', marginLeft: '10px' }}
        />
        <Typography
          fontSize="12px"
          lineHeight="177%"
          textColor={patientAccessTheme.palette.text.mediumemphasis}
        >
          Data is computed annually, please choose dates that are exactly one
          year apart for this screen
        </Typography>
      </Grid>
      <Grid className={classes.flex}>
        <DatePicker
          width="100%"
          handleChange={handleStartDateChange}
          selectedDate={formatDate(inputModalDates.startDate, 'MMMM YYYY')}
          minDate={minStartDate.format('MMMM YYYY')}
          maxDate={maxStartDate.format('MMMM YYYY')}
          format="MMMM yyyy"
          placeholder={'Select Start date'}
          error={!inputModalDates.startDate}
          views={['year', 'month']}
        />

        <DatePicker
          width="100%"
          selectedDate={formatDate(inputModalDates.endDate, 'MMMM YYYY')}
          format="MMMM yyyy"
          placeholder={'End date'}
          error={!inputModalDates.endDate}
          disabled // Prevent manual editing
          handleChange={() => {}}
          minDate={undefined}
          maxDate={undefined}
          views={['year', 'month']}
        />
      </Grid>
    </Grid>
  );
};

export default CustomDateSelection;
